import React, { useState } from "react";

import SoftBox from "../../../../components/SoftBox";
import SoftTypography from "../../../../components/SoftTypography";
import SoftInput from "../../../../components/SoftInput";
import AccountButton from "./AccountButton";

const PhoneCodePanel = ({ busy, cooldown, onConfirm, onResend, onCancel }) => {
  const [code, setCode] = useState("");
  const ready = code.length === 6;

  const submit = async () => {
    if (!ready || busy) return;
    const ok = await onConfirm(code);
    if (!ok) setCode("");
  };

  return (
    <SoftBox
      sx={{
        background: "#F9FAFB",
        border: "1px solid #EAECF0",
        borderRadius: "8px",
        padding: "16px",
      }}
    >
      <SoftTypography variant="h4">Enter the 6-digit code</SoftTypography>
      <SoftTypography
        sx={{ fontFamily: "DM Sans", fontSize: "13px", color: "#667085", mb: 1 }}
      >
        We texted it to your mobile number. It expires in 10 minutes.
      </SoftTypography>
      <SoftBox sx={{ display: "flex", gap: "12px", flexWrap: "wrap", alignItems: "center" }}>
        <SoftBox sx={{ flex: "1 1 180px", maxWidth: "260px" }}>
          <SoftInput
            name="phoneVerificationCode"
            placeholder="123456"
            autoComplete="one-time-code"
            inputProps={{ inputMode: "numeric", maxLength: 6 }}
            value={code}
            disabled={busy}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
            onKeyDown={(e) => {
              // Enter must confirm the code, not submit the whole profile form.
              if (e.key === "Enter") {
                e.preventDefault();
                submit();
              }
            }}
          />
        </SoftBox>
        <AccountButton
          type="button"
          variant="gradient"
          color="dark"
          disabled={!ready || busy}
          onClick={submit}
        >
          Confirm
        </AccountButton>
        <AccountButton
          type="button"
          variant="outline"
          disabled={busy || cooldown > 0}
          onClick={onResend}
        >
          {cooldown > 0 ? `Resend in ${cooldown}s` : "Resend code"}
        </AccountButton>
        <AccountButton type="button" variant="text" disabled={busy} onClick={onCancel}>
          Cancel
        </AccountButton>
      </SoftBox>
    </SoftBox>
  );
};

export default PhoneCodePanel;
